import { AreaModel, AreaModelAPI } from '../../../../models';

export const getAreasListAdapter = (responseAPI: AreaModelAPI[]): AreaModel[] => {
    return responseAPI
        ? responseAPI.map((area) => {
              return {
                  id: area.id,
                  isActive: area.isActive,
                  name: area.name,
              };
          })
        : [];
};
